import { render, staticRenderFns } from "./dutyListTemplate.vue?vue&type=template&id=2b0d082f&scoped=true&"
import script from "./dutyListTemplate.vue?vue&type=script&lang=ts&"
export * from "./dutyListTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./dutyListTemplate.vue?vue&type=style&index=0&id=2b0d082f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d082f",
  null
  
)

export default component.exports